<script lang="ts">
import { defineComponent } from 'vue';
import router from '../../router';
import { mapGetters } from 'vuex';
import { InteractiveContentPictureCounts } from '@/models/index';

export default defineComponent({
  name: 'FirstNotification',
  data () {
    return {
      count: 0
    };
  },
  created () {
    window.scrollTo(0, 0);
    // Browser backfunction detection
    // window.addEventListener('popstate', function () {
    //   router.push({ path: '/timeline/recommendation/0001' });
    // }, false);
  },
  computed: {
    ...mapGetters([
      'routeAddress'
    ])
  },
  methods: {
    gotoInteractive () {
      router.push({ path: '/interactive/rule-of-third', query: { type: this.routeAddress } });
    },
    onImgLoad () {
      this.count++;
      if (this.count === InteractiveContentPictureCounts.firstNotification) {
        this.$emit('scroll');
        this.$emit('load');
      }
    }
  }
});
</script>

<template>
  <main class="main" id="main">
      <div class="contents__manual is-color-purple">
        <section class="section__manual section__manual__mv">
          <div class="inner__manual">
            <!-- ▽ header H1 ▽ -->
            <h1 class="ttl__h1__manual">上手にスマホで撮影するなら基本の写真テク「三分割法」</h1>
            <!-- ▽ MV Image ▽ -->
            <div class="mv__manual"><img @load="onImgLoad" src="../../assets/recommendation/manual-02_img1.png" alt=""/></div>
            <!-- ▽ Text ▽-->
            <p class="txt__manual">被写体を中央に置いてしまい、どこか味気ない写真に毎回なってしまう…。スマートフォンでも写真の基本はかわりません。一歩グレードアップさせるなら「三分割法」をマスターするのがおすすめです。</p>
          </div>
        </section>
        <section class="section__manual section__manual__default">
          <div class="inner__manual">
            <!-- ▽ header H2 ▽-->
            <h2 class="ttl__h2__manual">初心者でもプロ級になる<br/>「三分割法」とは？</h2>
            <!-- ▽ Text ▽-->
            <p class="txt__manual">三分割法とは写真の基本的な構図のひとつ。スマートフォンのカメラには、設定により三分割法に用いる格子線＝グリッドラインを表示する機能もあります。このグリッドラインを被写体の配置目安にすると絶妙なバランスの写真撮影ができて、「これ、プロに撮ってもらったの？」と評価されるかもしれませんよ。</p>
          </div>
        </section>
        <section class="section__manual section__manual__default section__manual__colored">
          <div class="arrow_box">まずは実践！<br/>ゲーム感覚で三分割法を体験してみよう！</div>
          <div class="img__manual"><img @load="onImgLoad" src="../../assets/recommendation/manual-02_img2.png" alt=""/></div>
          <!-- ▽ Conversion Button ▽-->
          <div class="conversion__btn__manual" @click="gotoInteractive()"> <a href="">チャレンジ</a></div>
        </section>
      </div>
    </main>
</template>

<style lang="scss" scoped>
@import "@/styles/manual_notice.scss";
</style>
